import { render, staticRenderFns } from "./goods-details.vue?vue&type=template&id=0b10b318&scoped=true&"
import script from "./goods-details.vue?vue&type=script&lang=ts&"
export * from "./goods-details.vue?vue&type=script&lang=ts&"
import style0 from "./goods-details.vue?vue&type=style&index=0&id=0b10b318&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b10b318",
  null
  
)

export default component.exports